import React, { useEffect } from 'react';
import './FaceLivenessPage.css';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const FaceLivenessPage = ({ onAbort, children }) => {
  useEffect(() => {
    // Auto-scroll to hide address bar on mobile browsers
    const hideAddressBar = () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
    };
    hideAddressBar();
    window.addEventListener('orientationchange', hideAddressBar);
    
    return () => {
      window.removeEventListener('orientationchange', hideAddressBar);
    };
  }, []);
  
  return (
    <div className="container faceliveness-container" style={{position: 'relative'}}>
      <div>
        <div className="header" style={{position: 'relative'}}>
          <IconButton
            className="back-btn"
            onClick={onAbort}
            aria-label="abort"
            size="large"
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: '#fff',
              boxShadow: 1,
              zIndex: 10
            }}
          >
            <CloseIcon style={{color: '#121217'}} />
          </IconButton>
          <div className="headline">Schritt 3/3: Gesichtsüberprüfung</div>
        </div>
        <div className="content-section">
          {children}
          <div className="text-block hidden">
            <h2>Bitte platziere dein Gesicht innerhalb des Rahmens</h2>
            <p>Gehe sicher, dass dein ganzes Gesicht sich im Rahmen befindet und gut beleuchtet ist.</p>
          </div>
        </div>
      </div>
      <div style={{height: 72, width: '100%'}}></div>
    </div>
  );
};

export default FaceLivenessPage;
